const workflowTemplates = {
  // list screen
  workflow_templates: "Plantillas de flujo de trabajo",
  add_template: "Añadir plantilla",
  name: "Nombre",
  trigger: "Desencadenar",
  steps: "Pasos",
  status: "Estado",
  actions: "Acciones",
  active: "Activa",
  inactive: "Inactiva",
  edit: "Editar",
  open_builder: "Abrir editor",
  activate: "Activar",
  delete: "Eliminar",
  deactivate: "Desactivar",
  no_templates_found: "No se han encontrado plantillas de flujo de trabajo",
  no_templates_description:
    "Cree una plantilla de flujo de trabajo para empezar a diseñar un flujo de aprobación.",
  search: "Buscar",
  filters: "Filtros",
  all_triggers: "Todos los desencadenantes",
  all_statuses: "Todos",

  // template dialog
  create_template: "Crear plantilla de flujo de trabajo",
  edit_template: "Editar plantilla de flujo de trabajo",
  create_template_subtitle:
    "Crea una plantilla de flujo de trabajo para asignar diferentes tareas a distintos roles en varios pasos",
  edit_template_subtitle:
    "Cambia el nombre de la plantilla o modifica aquello a lo que se aplica.",
  template_name: "Nombre de la plantilla de flujo de trabajo",
  enter_template_name:
    "Introduce el nombre de la plantilla de flujo de trabajo",

  select_template_type: "Seleccionar desencadenante",
  template_type_payable_invoice: "Factura de compra",
  cancel: "Cancelar",
  save: "Guardar",
  create: "Crear",
  template_created_successfully:
    "Plantilla de flujo de trabajo creada correctamente",
  template_updated_successfully:
    "Plantilla de flujo de trabajo actualizada correctamente",
  template_deactivated_successfully:
    "Plantilla de flujo de trabajo desactivada correctamente",
  template_activated_successfully:
    "Plantilla de flujo de trabajo activada correctamente",
  template_deleted_successfully:
    "Plantilla de flujo de trabajo eliminada correctamente",
  template_name_required: "El nombre de la plantilla es obligatorio",
  template_name_max:
    "El nombre de la plantilla debe tener 150 caracteres o menos",
  template_type_required: "El tipo de plantilla es obligatorio",
  execution_order: "Orden de Ejecución",
  enter_execution_order: "Introducir orden de ejecución",
  execution_order_min: "El orden de ejecución no puede ser negativo",

  // deactivate dialog
  deactivate_template_title: "Desactivar plantilla de flujo de trabajo",
  deactivate_template_description:
    "Esta plantilla dejará de usarse para los nuevos documentos.",
  delete_template_title: "Eliminar plantilla de flujo de trabajo",
  delete_template_description:
    "Esta plantilla se eliminará de la lista de forma permanente. Esta acción no se puede deshacer.",

  // builder — chrome
  back: "Volver",
  unsaved_changes: "cambios sin guardar",
  save_changes: "Guardar cambios",
  saving: "Guardando",
  undo: "Deshacer",
  redo: "Rehacer",
  graph_saved_successfully: "Flujo de trabajo guardado correctamente",
  discard_changes_title: "¿Descartar los cambios sin guardar?",
  discard_changes_description:
    "Tiene cambios sin guardar en este flujo de trabajo. Si sale ahora, se descartarán.",

  // builder — add next step
  add_next_step: "Añadir siguiente paso",
  next_step_prompt: "¿Cuál será el siguiente paso?",
  assign_task: "Asignar tarea",
  assign_task_description: "Crear y asignar una tarea a un rol",
  condition_chooser_description: "Definir una condición",
  if_else: "Si / si no",
  if_else_description: "Divide el flujo en una rama Sí y una rama No",
  condition_needs_setup: "Necesita configuración",
  add_condition: "Añadir condición",
  condition_not_connected_configure:
    "La condición no está conectada a ningún paso anterior; configure la condición",
  read_only_hint: "No tiene permiso para editar este flujo de trabajo.",

  // builder — nodes
  start: "Inicio",
  end: "Fin",
  new_task: "Nueva tarea",
  new_condition: "Nueva condición",
  no_role_assigned: "Sin rol asignado",
  no_condition_set: "Sin condición definida",
  yes: "Sí",
  no: "No",

  // builder — inspector
  step_details: "Detalles del paso",
  step_type_start: "Inicio",
  step_type_end: "Fin",
  starts_workflow: "Inicia el flujo",
  ends_workflow: "Finaliza el flujo",
  step_type_user_task: "Tarea de usuario",
  step_type_condition: "Si / si no",
  step_name: "Nombre",
  who_is_it_assigned_to: "¿A quién está asignado?",
  what_is_the_task: "¿Cuál es la tarea?",
  role: "Rol",
  stage: "Etapa",
  task_name: "Nombre de la tarea",
  enter_task_name: "Introduzca el nombre de la tarea",
  description_optional: "Descripción (opcional)",
  action: "Acción",
  assigned_role: "Rol asignado",
  select_role: "Seleccione un rol",
  required_for_user_tasks: "Obligatorio para las tareas de usuario",
  assigned_stage: "Etapa",
  select_stage: "Seleccione una etapa",
  assigned_action: "Acción",
  select_action: "Seleccione una acción",
  required_action_for_user_tasks:
    "La acción es obligatoria para las tareas de usuario",
  description_label: "Descripción",
  description_placeholder: "Introduzca una descripción",
  required_description_for_user_tasks:
    "La descripción es obligatoria para las tareas de usuario",
  evaluate_condition_on_task_completion:
    "Evaluar condición al completar la tarea",
  remove_step: "Eliminar paso",
  remove_step_title: "¿Seguro que quieres eliminar este paso?",
  remove_step_description:
    "Este paso ya está configurado. Al eliminarlo también se borrarán sus conexiones, y no se podrá deshacer una vez que guardes.",
  condition: "Condición",
  condition_type: "Tipo de condición",
  select_condition_type: "Seleccione un tipo de condición",
  parameter: "Nombre del campo",
  select_parameter: "Seleccione el nombre del campo",
  operation: "Operación",
  select_operation: "Seleccione una operación",
  value: "Valor",
  enter_value: "Introduzca un valor",
  start_step_hint:
    "El flujo siempre empieza aquí. Conéctelo con su primer paso.",
  end_step_hint: "El flujo termina aquí.",
  edit_condition: "Editar condición",
  negate_yes_for_no: "Usar lo opuesto de Sí",

  // builder — checks
  checks: "Comprobaciones",
  checks_skipped_inactive_template:
    "Las comprobaciones se omiten mientras esta plantilla está inactiva, por lo que puede guardar un flujo de trabajo incompleto. Active la plantilla para aplicarlas.",
  all_checks_passed:
    "Todas las comprobaciones son correctas. Listo para guardar.",
  problems_to_fix_before_saving_one:
    "1 problema que corregir antes de guardar.",
  problems_to_fix_before_saving:
    "{{count}} problemas que corregir antes de guardar.",
  problems_leading_to_incomplete_workflow_one:
    "Problema que deja el flujo de trabajo incompleto",
  problems_leading_to_incomplete_workflow:
    "{{count}} Problemas que dejan el flujo de trabajo incompleto",
  warnings_count: "{{count}} advertencia(s)",
  fix: "Corregir",

  // builder — validation messages
  check_start_missing: "El flujo de trabajo debe tener un paso de Inicio.",
  check_start_multiple:
    "El flujo de trabajo solo puede tener un paso de Inicio.",
  check_start_has_incoming: '"{{name}}" no puede tener un paso anterior.',
  check_start_no_outgoing: '"{{name}}" debe tener un paso siguiente.',
  check_end_missing: "El flujo de trabajo debe tener al menos un paso de Fin.",
  check_end_has_outgoing: '"{{name}}" no puede tener un paso siguiente.',
  check_end_no_incoming: '"{{name}}" debe tener un paso anterior.',
  check_node_no_incoming: '"{{name}}" debe tener un paso anterior.',
  check_node_no_outgoing: '"{{name}}" debe tener un paso siguiente.',
  check_usertask_role_missing: 'La tarea "{{name}}" necesita un rol asignado.',
  check_usertask_description_missing:
    'La tarea "{{name}}" necesita una descripción.',
  check_usertask_action_missing:
    'La tarea "{{name}}" necesita una acción asignada.',
  check_condition_branch_count:
    '"{{name}}" debe tener exactamente dos ramas salientes (Sí/No).',
  check_condition_branch_missing_condition:
    '"{{name}}" necesita una condición completa en cada rama.',
  check_condition_branches_identical:
    'Las ramas Sí y No de "{{name}}" deben ser distintas.',
  check_non_condition_edge_has_condition:
    '"{{name}}" no es un paso Si / si no — sus conexiones salientes no pueden llevar una condición.',
  check_node_unreachable: 'No se puede llegar a "{{name}}" desde Inicio.',

  // bulk actions
  bulk_limit_exceeded: "Selecciona como máximo {{max}} plantillas a la vez",
  bulk_activate_title: "Activar plantillas de flujo de trabajo",
  bulk_activate_description: "¿Activar {{count}} plantilla(s) seleccionada(s)?",
  bulk_deactivate_title: "Desactivar plantillas de flujo de trabajo",
  bulk_deactivate_description:
    "{{count}} plantilla(s) seleccionada(s) dejarán de usarse para nuevos documentos.",
  bulk_delete_title: "Eliminar plantillas de flujo de trabajo",
  bulk_delete_description:
    "{{count}} plantilla(s) seleccionada(s) se eliminarán permanentemente de la lista. Esta acción no se puede deshacer.",
  templates_activated_successfully:
    "Plantillas de flujo de trabajo activadas correctamente",
  templates_deactivated_successfully:
    "Plantillas de flujo de trabajo desactivadas correctamente",
  templates_deleted_successfully:
    "Plantillas de flujo de trabajo eliminadas correctamente",
  "workflow-template-ids-required":
    "Selecciona al menos una plantilla de flujo de trabajo.",
  "workflow-template-delete-limit-exceeded":
    "Puedes eliminar como máximo {{0}} plantillas de flujo de trabajo a la vez.",
  "workflow-template-status-limit-exceeded":
    "Puedes activar o desactivar como máximo {{0}} plantillas de flujo de trabajo a la vez.",
  "workflow-template-not-found":
    "No se encontraron estas plantillas de flujo de trabajo: {{0}}",
  "workflow-template-has-pending-tasks":
    "Estas plantillas de flujo de trabajo tienen tareas pendientes: {{0}}",
  "workflow-template-cannot-activate-no-graph":
    "Estas plantillas de flujo de trabajo no tienen un gráfico de flujo y no se pueden activar: {{0}}",
  "workflow-template-cannot-activate-graph-invalid":
    '"{{0}}" no se puede activar: {{1}}',

  // errors
  something_went_wrong: "Algo ha ido mal",
  permission_not_granted: "Permiso no concedido",
  template_not_found: "Plantilla de flujo de trabajo no encontrada",
  trigger_title: "Cuando {{type}} es recibido",
};

export default workflowTemplates;
